"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.documentTypeEnumArray = exports.DocumentTypeEnum = void 0;
var DocumentTypeEnum;
(function (DocumentTypeEnum) {
    DocumentTypeEnum["INVOICE"] = "invoice";
    DocumentTypeEnum["DELIVERY_NOTE"] = "deliveryNote";
    DocumentTypeEnum["OFFER"] = "offer";
    DocumentTypeEnum["SPREADSHEET"] = "spreadsheet";
    DocumentTypeEnum["PURCHASE_ORDER"] = "purchaseOrder";
    DocumentTypeEnum["OTHER"] = "other";
})(DocumentTypeEnum || (exports.DocumentTypeEnum = DocumentTypeEnum = {}));
exports.documentTypeEnumArray = Object.values(DocumentTypeEnum);
